<div id="dashboard" [class.dashboard--signed-out-frontpage]="showSignedOutFrontpage">
  <main id="main-content">
    <ng-container *ngIf="userAuthenticationCheckPerformed && userIsAuthenticated && userIsAuthorized; else unauthenticatedState">
      <section class="workspace-section">
        <app-project-manager [dashboard]="this"></app-project-manager>
      </section>
    </ng-container>

    <ng-template #unauthenticatedState>
      <section id="userFailedAccessListCheckContainer" *ngIf="userAuthenticationCheckPerformed && userAuthorizationCheckPerformed && userIsAuthenticated && !userIsAuthorized">
        <h2>Missing access grant</h2>

        <p>
          You have successfully authenticated yourself as {{ userFullName }}, but you still lack the authorization to use this system.
          This is normally provided via invite codes, if you have such a code, please enter it below.
        </p>

        <app-invite-code-entry></app-invite-code-entry>

        <p>
          If you do not have an invite code and you would like to be granted access, please contact
          <a href="mailto:support@humlab.umu.se">support&#64;humlab.umu.se</a>.
        </p>
      </section>
    </ng-template>

    <app-help-dialog *ngIf="(modalActive && modalName=='help-dialog')"></app-help-dialog>
    <app-use-invite-code-dialog *ngIf="(modalActive && modalName=='use-invite-code-dialog')"></app-use-invite-code-dialog>
    <app-tratt-select-bundle-dialog *ngIf="(modalActive && modalName=='tratt-select-bundle-dialog')" [project]="modalArgs[0]"></app-tratt-select-bundle-dialog>
  </main>

  <aside id="infobar">
    <app-infobox-manager [expandedLayout]="showSignedOutFrontpage"></app-infobox-manager>
  </aside>
</div>
